import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/expand_more.svg?url_encode")